// Utils
import { useTranslation } from "src/design-system/core/TranslationContext";
import { useErrorPageStyles } from "../../hooks/styles/useErrorPageStyles";
import { ERROR_COMPONENTS_TRANSLATION_NAMESPACE, ERROR_PAGE_TK } from "./config";

// Components
import { Box, Button, Typography, useMediaQuery, useTheme } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import Page from "../Page";

interface ErrorPageProps {
    title?: string;
    subTitle?: string;
    description?: string;
    image?: string;
    refreshButtonText?: string;
    onGoHomeClick?: () => void;
}

export function ErrorPage({
    title,
    subTitle,
    description,
    image,
    refreshButtonText,
    onGoHomeClick,
}: ErrorPageProps): JSX.Element {
    const classes = useErrorPageStyles();
    const theme = useTheme();
    const mobileDevice = useMediaQuery(theme.breakpoints.down("sm"));
    const { t } = useTranslation(`${ERROR_COMPONENTS_TRANSLATION_NAMESPACE}:${ERROR_PAGE_TK}`);

    title = title || t("title");
    subTitle = subTitle || t("subtitle");
    description = description || t("description");
    image = image || "/static/images/undraw_bug_fixing_oc-7-a.svg";
    refreshButtonText = refreshButtonText || t("go-home");

    const handleGoHomeClick = () => {
        onGoHomeClick && onGoHomeClick();
    };

    return (
        <Page className={classes.root} title={title}>
            <Typography align="center" variant={mobileDevice ? "h3" : "h1"} color="textPrimary">
                {subTitle}
            </Typography>
            <Typography align="center" variant="subtitle" color="textSecondary">
                {description}
            </Typography>
            <Box mt={6} display="flex" justifyContent="center">
                <img alt="Error illustration" className={classes.image} src={image} />
            </Box>
            <Box mt={6} display="flex" justifyContent="center">
                <Button
                    color="primary"
                    component={RouterLink}
                    to="/"
                    variant="outlined"
                    onClick={handleGoHomeClick}
                >
                    {refreshButtonText}
                </Button>
            </Box>
        </Page>
    );
}
